<template>
  <section>
    <div
      class="document-form sme-container__info sme-container__info-document">
      <template v-if="!SMEProduct&&!isNewSME">
        <div class="box">
          <div class="table">
            <div class="th font-14" >Upload Document</div>
            <div
              v-if="showHKID"
              class="form-item tr">
              <span  v-if="formData.cust_typ == 2">Certificate of Incorporation/Business Registration Certificate</span>
              <span v-else>Policyholder HKID</span>
              <file-container
                :edit="fileEdit"
                :fileData="formData.id_type_pic"
                :otherData="{
                  target: 'id_type_pic',
                  type: 'id_type_pic_path'
                }"
                :uploadData="{
                  order_id: orderId,
                  type: 'id_type_pic_path'
                }"
                is-show-detail
                :direct="direct"
                titleName= "Policyholder HKID"
                @delete="handlerDeleteFile"
                @dock="handleDock"
                @uploadSuccess="handlerUploadSuccess" />
            </div>
            <div
              v-if="showDomestic"
              class="form-item tr">
              <span>Domestic Helper HKID/ Passport </span>
              <file-container
                :edit="fileEdit"
                :fileData="formData.domestic_id_type_pic"
                :otherData="{
                  target: 'domestic_id_type_pic',
                  type: 'domestic_id_type_pic_path'
                }"
                :uploadData="{
                  order_id: orderId,
                  type: 'domestic_id_type_pic_path'
                }"
                is-show-detail
                titleName= "Domestic Helper HKID/ Passport"
                :direct="direct"
                @delete="handlerDeleteFile"
                @dock="handleDock"
                @uploadSuccess="handlerUploadSuccess" />
            </div>
            <div
              v-if="showContract"
              class="form-item tr">
              <span>Contract</span>
              <file-container
                :edit="fileEdit"
                :fileData="formData.contract"
                :otherData="{
                  target: 'contract',
                  type: 'contract_path'
                }"
                :uploadData="{
                  order_id: orderId,
                  type: 'contract_path'
                }"
                is-show-detail
                :direct="direct"
                titleName= "Contract"
                @delete="handlerDeleteFile"
                @dock="handleDock"
                @uploadSuccess="handlerUploadSuccess" />
            </div>
            <div
              v-if="showNCB"
              class="form-item tr">
              <span>NCB proof (e.g. Renewal Notice)</span>
              <file-container
                :edit="fileEdit"
                :fileData="formData.ncd_proof"
                :otherData="{
                  target: 'ncd_proof',
                  type: 'ncd_proof_path'
                }"
                :uploadData="{
                  order_id: orderId,
                  type: 'ncd_proof_path'
                }"
                is-show-detail
                :direct="direct"
                titleName= "NCB proof (e.g. Renewal Notice)"
                @delete="handlerDeleteFile"
                @dock="handleDock"
                @uploadSuccess="handlerUploadSuccess" />
            </div>
            <div
              v-if="showVehicleReg"
              class="form-item tr">
              <span>Vehicle Registration Document</span>
              <upload-car
                v-if="!formData.rgtn_pic"
                @click="handleUploadVech"></upload-car>
              <file-container
                v-else
                :edit="fileEdit"
                :fileData="formData.rgtn_pic"
                :otherData="{
                  target: 'rgtn_pic',
                  type: 'rgtn_pic_path'
                }"
                :uploadData="{
                  order_id: orderId,
                  type: 'rgtn_pic_path'
                }"
                is-show-detail
                :direct="direct"
                titleName= "Vehicle Registration Document"
                is-car-vehicle
                @delete="handlerDeleteFile"
                @dock="handleDock"
                @carUpload="handleUploadVech"
                @uploadSuccess="handlerUploadSuccess" />
            </div>
            <div
              v-if="showVehicleReg"
              class="form-item tr">
              <span>Vehicle Registration Document with previous owner name / Vehicle Document</span>
              <file-container
                :edit="fileEdit"
                :fileData="formData.rgtn_with_owner_pic"
                :otherData="{
                  target: 'rgtn_with_owner_pic',
                  type: 'rgtn_with_owner_pic_path'
                }"
                :uploadData="{
                  order_id: orderId,
                  type: 'rgtn_with_owner_pic_path'
                }"
                is-show-detail
                :direct="direct"
                titleName= "Vehicle Registration Document with previous owner name / Vehicle Document"
                @delete="handlerDeleteFile"
                @dock="handleDock"
                @uploadSuccess="handlerUploadSuccess" />
            </div>

            <div
              v-if="showCert"
              class="form-item tr">
              <span>Business Registration Certificate</span>
              <file-container
                :edit="fileEdit"
                :fileData="formData.br_pic"
                :otherData="{
                  target: 'br_pic',
                  type: 'br_pic_path'
                }"
                :uploadData="{
                  order_id: orderId,
                  type: 'br_pic_path'
                }"
                is-show-detail
                :direct="direct"
                titleName= "Business Registration Certificate"
                @delete="handlerDeleteFile"
                @dock="handleDock"
                @uploadSuccess="handlerUploadSuccess" />
            </div>

            <div
              class="form-item tr">
              <span>No Know Loss Letter</span>
              <file-container
                :edit="fileEdit"
                :fileData="formData.loss_letter"
                :otherData="{
                  target: 'loss_letter',
                  type: 'loss_letter_path'
                }"
                :uploadData="{
                  order_id: orderId,
                  type: 'loss_letter_path'
                }"
                is-show-detail
                :direct="direct"
                titleName= "No Know Loss Letter"
                @delete="handlerDeleteFile"
                @dock="handleDock"
                @uploadSuccess="handlerUploadSuccess" />
            </div>

            <template v-if="showDrivers">
              <div class="tr">
                Insured Driver(s)
              </div>
              <div
                v-for="(item, index) in formData.nm_drvr_list"
                :key="index"
              >
                <div class="tr">{{ item.nm_drvr_lst_nm }} {{ item.nm_drvr_fst_nm }}</div>
                <div class="tr form-item">
                  <span class="label">HKID Card</span>
                  <file-container
                    :edit="fileEdit"
                    :fileData="driversFileList[index].idType"
                    :otherData="{
                      target: 'idType',
                      type: 'drivers',
                      index
                    }"
                    :uploadData="{
                      order_id: orderId,
                      type: 'nm_drvr_id_type_pic',
                      num: index
                    }"
                    :direct="direct"
                    is-show-detail
                    titleName= "HKID Card"
                    @delete="handlerDeleteFile"
                    @dock="handleDock"
                    @uploadSuccess="handlerUploadSuccess"
                  />
                </div>
                <div class="tr">
                  <span>Driver License</span>
                  <file-container
                    :edit="fileEdit"
                    :fileData="driversFileList[index].license"
                    :otherData="{
                      target: 'license',
                      type: 'drivers',
                      index
                    }"
                    :uploadData="{
                      order_id: orderId,
                      type: 'nm_drvr_licence_pic',
                      num: index
                    }"
                    is-show-detail
                    :direct="direct"
                    titleName= "Driver License"
                    @delete="handlerDeleteFile"
                    @dock="handleDock"
                    @uploadSuccess="handlerUploadSuccess"
                  />
                </div>

              </div>
            </template>

            <template v-if="showHomeFire&&hasBenefitsEmployees">
              <div class="tr">
                Domestic Helper Information
              </div>
              <div
                v-for="(item, index) in formData.domestic_helper_info"
                :key="'domestic_helper_info'+index"
                class="document-table">
                <span class="label tr">{{ item.name }}</span>
                <div class="tr">
                  <span class="label">HKID / Passport</span>
                  <file-container
                    :edit="fileEdit"
                    :fileData="item.id_type_pic"
                    :otherData="{
                      type: 'nm_domestic_id_type_pic',
                      index
                    }"
                    :uploadData="{
                      order_id: orderId,
                      type: 'nm_domestic_id_type_pic',
                      num: index
                    }"
                    :direct="direct"
                    is-show-detail
                    titleName= "HKID / Passport"
                    @delete="handlerHomeDeleteFile"
                    @dock="handleDock"
                    @uploadSuccess="handlerUploadSuccess"
                  />
                </div>
              </div>
            </template>
            <template v-if="showHomeFire&&hasBenefitsPets">
              <div class="tr">Pet Information</div>
              <div
                v-for="(item, index) in formData.pet_info"
                :key="'pet_info'+index"
                class="document-table">
                <span class="label tr">{{ item.name }}</span>
                <div class="tr">
                  <span class="label">Microchip Copy</span>
                  <file-container
                    :edit="fileEdit"
                    :fileData="item.microchip_copy_pic"
                    :otherData="{
                      target: 'microchip_copy_pic',
                      type: 'microchip_copy_pic',
                      index
                    }"
                    :uploadData="{
                      order_id: orderId,
                      type: 'microchip_copy_pic',
                      num: index
                    }"
                    :direct="direct"
                    is-show-detail
                    titleName= "Microchip Copy"
                    @delete="handlerHomeDeleteFile"
                    @dock="handleDock"
                    @uploadSuccess="handlerUploadSuccess"
                  />
                </div>
              </div>
            </template>
            <template v-if="showTravel">
              <div class="tr">Traveller Information</div>
              <div
                v-for="(item, index) in formData.nm_traveler_list"
                :key="'traveler'+index"
                class="document-table"
              >
                <span class="label tr">{{`${item.lst_nm} ${item.fst_nm}`}}</span>
                <div class="tr">
                  <span class="label">HKID / Passport</span>
                  <file-container
                    :edit="fileEdit"
                    :fileData="{
                      url: item.id_type_pic_url,
                      client_name: item.client_name,
                      thumb_url: item.id_type_pic_url
                    }"
                    :otherData="{
                      type: 'traveler_id_type_pic',
                      index
                    }"
                    :uploadData="{
                      order_id: orderId,
                      type: 'traveler_id_type_pic',
                      num: index
                    }"
                    is-show-detail
                    :direct="direct"
                    titleName= "HKID / Passport"
                    @delete="handlerHomeDeleteFile"
                    @dock="handleDock"
                    @uploadSuccess="handlerUploadSuccess"
                  />
                </div>
              </div>
            </template>

            <template v-if="showPAFamily">
              <div class="tr">Insured Information</div>
              <div
                v-for="(item, index) in formData.nm_pa_list"
                :key="'nm_pa_list'+index"
                class="document-table"
              >
                <span class="label tr">{{`${item.lst_nm} ${item.fst_nm}`}}</span>
                <div class="tr">
                  <span class="label">HKID / Passport</span>
                  <file-container
                    :edit="fileEdit"
                    :fileData="{
                      url: item.id_type_pic_url,
                      client_name: item.client_name,
                      thumb_url: item.id_type_pic_url
                    }"
                    :otherData="{
                      type: 'pa_id_type_pic',
                      index
                    }"
                    :uploadData="{
                      order_id: orderId,
                      type: 'pa_id_type_pic',
                      num: index
                    }"
                    is-show-detail
                    :direct="direct"
                    titleName= "HKID / Passport"
                    @delete="handlerHomeDeleteFile"
                    @dock="handleDock"
                    @uploadSuccess="handlerUploadSuccess"
                  />
                </div>
              </div>
            </template>
            <template v-if="showStudent">
              <!--      <h3>Insured Student Details</h3>-->
              <div
                class="form-item tr">
                <span>Insured Student HKID</span>
                <file-container
                  :edit="fileEdit"
                  :fileData="{
                    thumb_url:student_info.id_type_pic_thumb_url,
                    url:student_info.id_type_pic_url,
                    client_name:student_info.id_type_pic_path_id
                  }"
                  :otherData="{
                    target: 'student_id_type_pic',
                    type: 'student_id_type_pic'
                  }"
                  :uploadData="{
                    order_id: orderId,
                    type: 'student_id_type_pic   '
                  }"
                  :direct="direct"
                  is-show-detail
                  titleName= "Insured Student HKID"
                  @delete="handlerDeleteFile"
                  @dock="handleDock"
                  @uploadSuccess="handlerUploadSuccess" />
              </div>

              <div
                v-if="hasAcc"
                class="form-item tr">
                <span >Accompanying Parent or Guardian HKID</span>
                <file-container
                  :edit="fileEdit"
                  :fileData="{
                    thumb_url:acc_parent_info.id_type_pic_thumb_url,
                    url:acc_parent_info.id_type_pic_url,
                    client_name:acc_parent_info.id_type_pic_path_id
                  }"
                  :otherData="{
                    target: 'acc_parent_id_type_pic  ',
                    type: 'acc_parent_id_type_pic  '
                  }"
                  :uploadData="{
                    order_id: orderId,
                    type: 'acc_parent_id_type_pic     '
                  }"
                  :direct="direct"
                  is-show-detail
                  titleName= "Accompanying Parent or Guardian HKID"
                  @delete="handlerDeleteFile"
                  @dock="handleDock"
                  @uploadSuccess="handlerUploadSuccess" />
              </div>
            </template>
            <div
              v-if="!showTravel&&!showStudent&&!showWorking&&!showPersonal&&!showPet"
              class="tr">
              <span v-if="formData.other_file">Additional Documents</span>
              <div
                v-for="(item, index) in formData.other_file"
                :key="index + 'other'"
                class="form-item">
                <!-- <span>Vehicle Registration Document (Optional)</span> -->
                <file-container
                  :fileData="item"
                  :edit="fileEdit"
                  :uploadData="{
                    order_id: orderId,
                    type: 'other_file',
                    num: index
                  }"
                  :otherData="{
                    index,
                    target: 'other_file'
                  }"
                  :direct="direct"
                  is-show-detail
                  titleName="Additional Documents"
                  @delete="handlerDeleteFile"
                  @dock="handleDock"
                  @uploadSuccess="handlerUploadSuccess" />
              </div>
              <v-upload
                v-if="fileEdit"
                card
                right
                is-show-detail
                :otherData="{
                  type: 'other',
                  target: 'other_file',
                  index: otherFileLength
                }"
                :uploadData="{
                  order_id: orderId,
                  type: 'other_file',
                  num: otherFileLength
                }"
                :direct="direct"
                @uploadSuccess="handlerUploadSuccess" />
            </div>
            <section
              v-if="inter"
              class="tr">
              <span>Internal Documents</span>
              <div
                v-for="(item, index) in formData.inter_file"
                :key="index + 'inter'"
                class="form-item">
                <file-container
                  :fileData="item"
                  :edit="true"
                  :otherData="{
                    index,
                    target: 'inter_file'
                  }"
                  :uploadData="{
                    order_id: orderId,
                    type: 'inter_file',
                    num: index
                  }"
                  is-show-detail
                  :direct="direct"
                  titleName= "Internal Documents"
                  @delete="handlerDeleteFile"
                  @dock="handleDock"
                  @uploadSuccess="handlerUploadSuccess" />
              </div>
              <v-upload
                card
                right
                :otherData="{
                  type: 'other',
                  target: 'inter_file',
                  index: interFileLength
                }"
                :uploadData="{
                  order_id: orderId,
                  type: 'inter_file',
                  num: interFileLength
                }"
                is-show-detail
                :direct="direct"
                @uploadSuccess="handlerUploadSuccess" />
            </section>
          </div>
        </div>
      </template>
      <template v-if="SMEProduct&&!isNewSME">
        <el-form
          ref="form"
          :model="formData">
          <div class="travel-box box">
            <div class="table">
              <div class="th font-14" >Upload Document</div>
              <div
                class="form-item tr">
                <span>Business Registration Certificate</span>
                <!--            <span>-->
                <file-container
                  :edit="fileEdit"
                  is-show-detail
                  :fileData="formData.br_files_type_pic"
                  :otherData="{
                    target: 'br_files_type_pic',
                    type: 'br_files'
                  }"
                  :uploadData="{
                    order_id: orderId,
                    type: 'br_files',
                    target:'br_files_type_pic'
                  }"
                  :direct="direct"
                  titleName= "Business Registration Certificate"
                  @delete="handlerDeleteBRFile"
                  @dock="handleDock"
                  @uploadSuccess="handlerUploadSuccess" />
                <!--            </span>-->
              </div>
              <div class="form-item tr">
                <span>Latest 3 months Contribution Record </span>
                <el-form-item
                  ref="upload_document.mpf_files"
                  prop="upload_document.mpf_files">

                  <file-container
                    v-for="(item, index) in formData.upload_document.mpf_files"
                    :key="index"
                    :edit="true"
                    is-show-detail
                    :fileData="item"
                    :otherData="{
                      index,
                      type:'mpf_files',
                      target: 'mpf_files'
                    }"
                    :uploadData="{
                      index,
                      order_id: orderId,
                      type:'mpf_files',
                      target: 'mpf_files'
                    }"
                    :direct="direct"
                    titleName= "MPF Documents"
                    @delete="handlerDeleteFile"
                    @uploadSuccess="handlerUploadSuccess"
                    @dock="handleDock"
                  />
                  <v-upload
                    card
                    right
                    is-show-detail
                    :otherData="{
                      type:'mpf_files',
                      target: 'mpf_files',
                      index:mpf_files_length
                    }"
                    :uploadData="{
                      order_id: orderId,
                      type:'mpf_files',
                      target: 'mpf_files',
                      num:mpf_files_length
                    }"
                    :direct="direct"
                    @uploadSuccess="handlerUploadSuccess" />
                </el-form-item>
              </div>
              <div
                class="form-item tr">
                <span>Renewal Notice / Existing Policy (Optional)</span>
                <el-form-item
                  ref="upload_document.renewal_files"
                  prop="upload_document.renewal_files">
                  <file-container
                    v-for="(item, index) in formData.upload_document.renewal_files"
                    :key="index"
                    :edit="true"
                    :fileData="item"
                    is-show-detail
                    :otherData="{
                      index,
                      target: 'renewal_files',
                      type:'renewal_files',
                    }"
                    :uploadData="{
                      index,
                      order_id: orderId,
                      target: 'renewal_files',
                      type:'renewal_files',
                    }"
                    :direct="direct"
                    titleName= "Renewal Documents"
                    @delete="handlerDeleteFile"
                    @dock="handleDock"
                    @uploadSuccess="handlerUploadSuccess"
                  />
                  <v-upload
                    card
                    right
                    :otherData="{
                      type:'renewal_files',
                      target: 'renewal_files',
                      index:renewal_files_length
                    }"
                    :uploadData="{
                      order_id: orderId,
                      target: 'renewal_files',
                      type:'renewal_files',
                      num:renewal_files_length
                    }"
                    is-show-detail
                    :direct="direct"
                    @uploadSuccess="handlerUploadSuccess" />
                </el-form-item>
              </div>
              <div
                class="form-item tr">
                <span>List of  machines / devices to be insured (valued over HK$100,000 per item/set)</span>
                <el-form-item
                  ref="upload_document.device_files"
                  prop="upload_document.device_files">
                  <file-container
                    v-for="(item, index) in formData.upload_document.device_files"
                    :key="index"
                    :edit="true"
                    is-show-detail
                    :fileData="item"
                    :otherData="{
                      index,
                      target: 'device_files',
                      type:'device_files',
                    }"
                    :uploadData="{
                      index,
                      order_id: orderId,
                      target: 'device_files',
                      type:'device_files',
                    }"
                    :direct="direct"
                    titleName= "Device Documents"
                    @delete="handlerDeleteFile"
                    @dock="handleDock"
                    @uploadSuccess="handlerUploadSuccess"
                  />
                  <v-upload
                    right
                    :otherData="{
                      type:'device_files',
                      target: 'device_files',
                      index:device_files_length
                    }"
                    :uploadData="{
                      order_id: orderId,
                      target: 'device_files',
                      type:'device_files',
                      num:device_files_length
                    }"
                    is-show-detail
                    :direct="direct"
                    @uploadSuccess="handlerUploadSuccess" />
                </el-form-item>
              </div>
            </div>
          </div>
        </el-form>
      </template>
      <template v-if="isNewSME">
        <el-form
          ref="form"
          :rules="rules"
          :model="formData">
          <div class="travel-box box">
            <div class="table">
              <div class="th font-14" >Upload Document</div>
              <div
                class="form-item tr">
                <span>Renewal Notice or 3rd Party Quotation</span>
                <!--            <span>-->
                <file-container
                  :edit="fileEdit"
                  is-show-detail
                  :fileData="formData.renew_file"
                  :otherData="{
                    target: 'renew_file',
                    type: 'renewal_files',
                    idKey: 'renew_file_id',
                  }"
                  :uploadData="{
                    order_id: orderId,
                    type: 'renewal_files',
                    target:'renew_file',
                    idKey: 'renew_file_id',
                  }"
                  :direct="direct"
                  titleName= "Renewal Notice or 3rd Party Quotation"
                  @delete="handlerDeleteSMEFile"
                  @dock="handleDock"
                  @uploadSuccess="handlerUploadSMESuccess" />
                <!--            </span>-->
              </div>
              <div
                class="form-item tr">
                <span>Business Registration Certificate</span>
                <el-form-item
                  ref="br_file"
                  :rules="rules.upload"
                  prop="br_file">
                  <file-container
                    :edit="fileEdit"
                    is-show-detail
                    :fileData="formData.br_file"
                    :otherData="{
                      target: 'br_file',
                      idKey: 'br_file_id',
                      type: 'br_files',

                    }"
                    :uploadData="{
                      order_id: orderId,
                      type: 'br_files',
                      idKey: 'br_file_id',
                      target:'br_file'
                    }"
                    :direct="direct"
                    titleName= "Business Registration Certificate"
                    @delete="handlerDeleteSMEFile"
                    @dock="handleDock"
                    @uploadSuccess="handlerUploadSMESuccess" />
                </el-form-item>
              </div>
              <div class="form-item tr">
                <span>Latest 3 months Contribution Record </span>
                <el-form-item
                  ref="mpf_files"
                  prop="mpf_files">

                  <file-container
                    v-for="(item, index) in formData.mpf_files"
                    :key="index"
                    :edit="true"
                    is-show-detail
                    :fileData="item"
                    :otherData="{
                      index,
                      type:'mpf_files',
                      target: 'mpf_files'
                    }"
                    :uploadData="{
                      index,
                      order_id: orderId,
                      type:'mpf_files',
                      target: 'mpf_files'
                    }"
                    :direct="direct"
                    titleName= "MPF Documents"
                    @delete="handlerDeleteSMEFile"
                    @uploadSuccess="handlerUploadSMEIndexSuccess"
                    @dock="handleDock"
                  />
                  <v-upload
                    card
                    right
                    is-show-detail
                    :otherData="{
                      type:'mpf_files',
                      target: 'mpf_files',
                      index:mpf_files_length
                    }"
                    :uploadData="{
                      order_id: orderId,
                      type:'mpf_files',
                      target: 'mpf_files',
                      num:mpf_files_length
                    }"
                    :direct="direct"
                    @uploadSuccess="handlerUploadSMESuccess" />
                </el-form-item>
              </div>
              <div
                class="form-item tr">
                <span>Insurer Application Form</span>
                <el-form-item
                  ref="prop_pdf_path_file"
                  prop="prop_pdf_path_file">
                  <file-container
                    :edit="fileEdit"
                    is-show-detail
                    :fileData="formData.prop_pdf_path_file"
                    :otherData="{
                      target: 'prop_pdf_path_file',
                      idKey: 'prop_pdf_path',
                      type: 'prop_pdf_path',

                    }"
                    :uploadData="{
                      order_id: orderId,
                      type: 'prop_pdf_path',
                      idKey: 'prop_pdf_path',
                      target:'prop_pdf_path_file'
                    }"
                    :direct="direct"
                    titleName= "Insurer Application Form"
                    @delete="handlerDeleteSMEFile"
                    @dock="handleDock"
                    @uploadSuccess="handlerUploadSMESuccess" />
                </el-form-item>
              </div>
              <div
                class="form-item tr">
                <span>Insurer Official Quotation</span>
                <el-form-item
                  ref="insurer_quotation_path_file"
                  prop="insurer_quotation_path_file">
                  <file-container
                    :edit="fileEdit"
                    is-show-detail
                    :fileData="formData.insurer_quotation_path_file"
                    :otherData="{
                      target: 'insurer_quotation_path_file',
                      idKey: 'insurer_quotation_path',
                      type: 'insurer_quotation_path',

                    }"
                    :uploadData="{
                      order_id: orderId,
                      type: 'insurer_quotation_path',
                      idKey: 'insurer_quotation_path',
                      target:'insurer_quotation_path_file'
                    }"
                    :direct="direct"
                    titleName= "Business Registration Certificate"
                    @delete="handlerDeleteSMEFile"
                    @dock="handleDock"
                    @uploadSuccess="handlerUploadSMESuccess" />
                </el-form-item>
              </div>
              <div
                class="tr">
                <span>Internal Documents</span>
                <div
                  v-for="(item, index) in formData.internal_files"
                  :key="index + 'internal_files'"
                  class="form-item">
                  <file-container
                    :fileData="item"
                    :edit="true"
                    :otherData="{
                      index,
                      target: 'internal_files'
                    }"
                    :uploadData="{
                      order_id: orderId,
                      type: 'internal_files',
                      num: index
                    }"
                    is-show-detail
                    :direct="direct"
                    titleName= "Internal Documents"
                    @delete="handlerDeleteSMEFile"
                    @dock="handleDock"
                    @uploadSuccess="handlerUploadSMEIndexSuccess" />
                </div>
                <v-upload
                  card
                  right
                  :otherData="{
                    type: 'other',
                    target: 'internal_files',
                    index: interFilesLength
                  }"
                  :uploadData="{
                    order_id: orderId,
                    type: 'internal_files',
                    num: interFilesLength
                  }"
                  is-show-detail
                  :direct="direct"
                  @uploadSuccess="handlerUploadSMESuccess" />
              </div>
            </div>
          </div>
        </el-form>
      </template>
    </div>

    <show-detail-dialog
      v-model="showDetail"
      :file="file"
      :customer="customer"
      :form="form"></show-detail-dialog>
    <upload-vechic-dialog
      v-model="uploadVech"
      :form="form"
      @success="handleUpdate"></upload-vechic-dialog>
  </section>
</template>
<script>
import FileContainer from '@/views/components/file-container'
import ShowDetailDialog from '@/views/records/policy/components/dialog/show-detail'
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import MixinRules from '@/mixins/rules'
import uploadCar from './upload-card'
import uploadVechicDialog from '../dialog/upload-vechic-dialog'
export default {
  name: 'DocumentForm',
  components: {
    ShowDetailDialog,
    FileContainer,
    uploadCar,
    uploadVechicDialog
  },
  mixins: [MixinOptions, MixinFormat, MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    customer: {
      type: Object,
      default: () => ({})
    },
    inter: {
      type: Boolean,
      default: false  //  控制是否顯示内部文件
    },
    orderId: {
      type: [String, Number],
      default: ''
    },
    policyForm: {
      type: Object,
      default: () => ({})
    },
    formDataLock: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      showDetail:false,
      uploadVech:false,
      oldFormDataLock: -1,
      formData: {
        mpf_files:[],
        internal_files:[],
        br_file:{},
        br_file_id:'',
        renew_file:{},
        renew_file_id:'',
        prop_pdf_path:'',
        insurer_quotation_path:'',
        prop_pdf_path_file:{},
        insurer_quotation_path_file:{},
        id_type_pic: {},
        ncd_proof: {},
        rgtn_pic: {thumb_url:'',url:''},
        rgtn_with_owner_pic: {},
        nm_drvr_list: [],
        other_file: [],
        inter_file: [],
        domestic_id_type_pic: {},
        cert_of_inc_pic: {},
        br_pic: {},
        contract: {},
        cust_typ: 1,
        pet_info:[],
        domestic_helper_info:[],
        nm_traveler_list:[],
        nm_pa_list:[],
        student_info:{},
        acc_parent_info:{},
        upload_document:{
          br_files:[],
          mpf_files:[],
          renewal_files:[],
          device_files:[],
        },
        br_files_type_pic: {},
        br_files_path_id: '',
        br_files_type_pic_path: '',
        loss_letter: {}
      },
      direct: 0, // 直接入庫
      file:{}
    }
  },
  computed: {
    isNewSME(){
      let {sme_versions} = this.$route.query||{}
      return sme_versions==3
    },
    productId() {
      return Number(this.form.product_id) || 11
    },
    SMEProduct(){
      return this.productId==80
    },
    driversFileList() {
      let nm_drvr_list = this.formData.nm_drvr_list
      return nm_drvr_list.reduce((result, item) => {
        if(!item) {
          result.push({})
        }
        else {
          result.push({
            idType: {
              url: item.nm_drvr_id_type_pic_url,
              thumb_url: item.nm_drvr_id_type_pic_thumb_url,
              id: item.nm_drvr_id_type_pic_path_id,
              path: item.nm_drvr_id_type_pic_path
            },
            license: {
              url: item.nm_drvr_licence_pic_url,
              thumb_url: item.nm_drvr_licence_pic_thumb_url,
              id: item.nm_drvr_licence_pic_path_id,
              path: item.nm_drvr_licence_pic_path
            }
          })
        }
        return result
      }, [])
    },
    fileEdit() {
      return  true
      const { stts } = this.policyForm
      return stts < 420
    },
    policyStts() {
      return this.policyForm.stts
    },
    otherFileLength() {
      if(!this.formData.other_file) {
        return 0
      }
      return this.formData.other_file.length
    },
    device_files_length() {
      let {device_files=[]} = this.formData.upload_document||{}
      if(!device_files) {
        return 0
      }
      return device_files.length
    },
    renewal_files_length() {
      let {renewal_files=[]} = this.formData.upload_document||{}
      if(!renewal_files) {
        return 0
      }
      return renewal_files.length
    },
    mpf_files_length() {
      if(this.isNewSME){
        const {mpf_files=[]} = this.formData||{}
        if(!mpf_files) {
          return 0
        }
        return mpf_files.length
      }
      let {mpf_files=[]} = this.formData.upload_document||{}
      if(!mpf_files) {
        return 0
      }
      return mpf_files.length
    },
    interFileLength() {
      if(!this.formData.inter_file) {
        return 0
      }
      return this.formData.inter_file.length
    },
    interFilesLength() {
      if(!this.formData.internal_files) {
        return 0
      }
      return this.formData.internal_files.length
    },
    showHKID() {
      return [11, 12, 15, 17,14,16,13,20,18,22].includes(this.productId)
    },
    showNCB() {
      return [11].includes(this.productId)
    },

    showVehicleReg() {
      return [11].includes(this.productId)
    },
    showCert() {
      return [11, 15, 17].includes(this.productId)
        && this.formData.cust_typ == 2
    },
    showDrivers() {
      return [11].includes(this.productId)
    },
    showDomestic() {
      return [12].includes(this.productId)
    },
    showContract() {
      return [15].includes(this.productId)
    },
    showHomeFire(){
      return [17,20].includes(this.productId)
    },
    showTravel(){
      return [14].includes(this.productId)
    },

    showStudent(){
      return [16].includes(this.productId)
    },
    showWorking() {
      return [13].includes(this.productId)
    },
    showPersonal() {
      return [18].includes(this.productId)
    },
    showPet() {
      return [22].includes(this.productId)
    },
    hasBenefitsEmployees() {
      const { benefits = [] } = this.form
      if(benefits && benefits.includes(1)) {
        return true
      }
      return false
    },
    hasBenefitsPets() {
      const { benefits = [] } = this.form
      if(benefits && benefits.includes(4)) {
        return true
      }
      return false
    },
    benefits(){
      const { benefits = [] } = this.form
      return benefits
    },

    student_info() {
      let {student_info}= this.formData||{}
      return student_info||{}
    },
    acc_parent_info() {
      let {acc_parent_info}= this.formData||{}
      return acc_parent_info||{}
    },
    hasAcc() {
      let {benefits=[]}= this.formData||{}
      return benefits.includes(2)
    },
    showPAFamily(){
      return [18].includes(this.productId)&&this.isFamily
    },
    isFamily(){
      let {type_of_insured} = this.form||{}
      return type_of_insured==2
    },
  },
  watch: {
    // 表單鎖，外層會更新，數值變化了才可以更新 formData
    formDataLock: {
      handler(val, old = -1) {
        if(val !== old) {
          this.oldFormDataLock = old
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        if(this.formDataLock !== this.oldFormDataLock) {
          // 觸發更新就賦值，避免二次更新
          this.oldFormDataLock = this.formDataLock
          Object.keys(this.formData).some(key => {

            if(key in val) {
              this.formData[key] = JSON.parse(JSON.stringify(val[key]))
            }
            if(key=='rgtn_pic'){
            }
          })
          let {upload_document={}} = val
          let {br_files=[]} =upload_document
          this.formData.br_files_type_pic = br_files[0]
          this.uploadName()
        }
        if(this.productId==80&&!this.isNewSME){
          let {upload_document={}} = val
          let {br_files=[]} =upload_document
          this.formData.upload_document = upload_document
          this.formData.br_files_type_pic = br_files[0]
          this.uploadName()
        }
        if(this.isNewSME){
          let {insurer_quotation_file,prop_pdf_file} = val||{}
          if(insurer_quotation_file){
            let {id} = insurer_quotation_file||{}
            this.formData.insurer_quotation_path = id
            this.formData.insurer_quotation_path_file = insurer_quotation_file
          }
          if(prop_pdf_file){
            let {id} = prop_pdf_file||{}
            this.formData.prop_pdf_path = id
            this.formData.prop_pdf_path_file = prop_pdf_file
          }
          this.uploadName()
        }
      }
    }
  },
  methods: {
    handleUpdate(data){
      let {rgtn_pic} = data||{}
      this.formData.rgtn_pic = rgtn_pic||{}
      this.$emit('update')
      this.uploadName()
    },
    handleUploadVech(){
      this.uploadVech =true
    },
    handleDock(data){
      this.file  =data
      this.showDetail = true
    },
    uploadName(){
      let tabName =[]
      let {nm_traveler_list=[],id_type_pic={},cust_typ,domestic_id_type_pic,contract,ncd_proof,rgtn_pic,rgtn_with_owner_pic,br_pic,cert_of_inc_pic,pet_info,domestic_helper_info,upload_document,ncd_pct,already_owned_by_ind,br_file,insurer_quotation_file,prop_pdf_file} = this.formData
      if(this.showHKID&&!id_type_pic){
        if(cust_typ==2){
          tabName.push('Business Registration Certification')
        }else if(cust_typ==1 && this.productId != 14){
          tabName.push('Policyholder HKID')
        }
      }
      if(this.showDomestic&&!domestic_id_type_pic)
        tabName.push('Domestic Helper HKID/ Passport')
      if(this.showContract&&!contract)
        tabName.push('contract')
      if(this.showNCB&&!ncd_proof&&ncd_pct > 0)
        tabName.push('NCB proof (e.g. Renewal Notice)')
      // if(this.showVehicleReg&&!rgtn_pic&&already_owned_by_ind)
      //   tabName.push('Vehicle Registration Document')
      // if(this.showVehicleReg&&!rgtn_with_owner_pic&&!already_owned_by_ind)
      //   tabName.push('Vehicle Registration Document with previous owner name / Vehicle Document')
      if(this.showCert&&!br_pic)
        tabName.push('Business Registration Certificate')
      if(this.showDrivers)
      {
        let idType =  this.driversFileList.filter(item=>{
          let {idType} = item||{}
          let {id} = idType||{}
          return !id
        })
        let lisceneType =  this.driversFileList.filter(item=>{
          let {license} = item||{}
          let {id} = license||{}
          return !id
        })
        if(idType.length>0)
          tabName.push('Insured Driver(s) HKID Card')
        if(lisceneType.length>0)
          tabName.push('Insured Driver(s) License')
      }
      if(this.showHomeFire&&this.hasBenefitsEmployees)
      {
        let info =  domestic_helper_info.filter(item=>{
          let {id_type_pic} = item||{}
          let {id} = id_type_pic||{}
          return !id
        })
        if(info.length>0)
          tabName.push('Domestic Helper Information')
      }
      if(this.showHomeFire&&this.hasBenefitsPets)
      {
        let info =  pet_info.filter(item=>{
          let {microchip_copy_pic} = item||{}
          let {id} = microchip_copy_pic||{}
          return !id
        })
        if(info.length>0)
          tabName.push('Pet Information')
      }
      if(this.showTravel)
      {
        let info =  nm_traveler_list.filter(item=>{
          return !item
        })
        if(info.length>0)
          tabName.push('Traveller Information')
      }
      if(this.showStudent&&!this.student_info.id_type_pic_thumb_url)
      {
        tabName.push('Insured Student HKID')
      }
      if(this.hasAcc&&!this.acc_parent_info.id_type_pic_thumb_url)
      {
        tabName.push('Accompanying Parent or Guardian HKID')
      }
      if(this.productId==80&&!this.isNewSME){
        if(upload_document.br_files.length<=0)
          tabName.push('Business Registration Certificate')
        if(upload_document.mpf_files.length<=0)
          tabName.push('Latest 3 months Contribution Record')
        if(upload_document.renewal_files.length<=0)
          tabName.push('Renewal Notice / Existing Policy (Optional)')
        if(upload_document.device_files.length<=0)
          tabName.push('List of  machines / devices to be insured (valued over HK$100,000 per item/set)')
      }
      if(this.isNewSME){
        if(!br_file)
          tabName.push('Business Registration Certificate')
        if(!insurer_quotation_file){
          tabName.push('Insurer Official Quotation')
        }
        if(!prop_pdf_file){
          tabName.push('Insurer Application Form')
        }
      }
      this.$emit('tabName',tabName)
    },
    // 更新記名司機文件
    updateDriversFile(data) {
      const { index, name, id, url, idKey, nameKey } = data
      if(!this.formData.nm_drvr_list[index]) {
        const temp = {
          nm_drvr_lst_nm: '',
          nm_drvr_fst_nm: '',
          nm_drvr_id_type_pic_url: '',
          nm_drvr_id_type_pic_thumb_url: '',
          nm_drvr_id_type_pic_path_id: '',
          nm_drvr_id_type_pic_path: '',
          nm_drvr_licence_pic_url: '',
          nm_drvr_licence_pic_thumb_url: '',
          nm_drvr_licence_pic_path_id: '',
          nm_drvr_licence_pic_path: ''
        }
        for(let i = 0; i <= index; i++) {
          if(!this.formData.nm_drvr_list[i]) {
            this.$set(this.formData.nm_drvr_list, i, {
              ...temp
            } )
          }
        }
      }
      this.formData.nm_drvr_list[index][idKey] = id
      this.formData.nm_drvr_list[index][nameKey] = name
      if(idKey === 'nm_drvr_id_type_pic_path_id') {
        this.formData.nm_drvr_list[index].nm_drvr_id_type_pic_url = url
      } else {
        this.formData.nm_drvr_list[index].nm_drvr_licence_pic_url = url
      }
    },
    submitForm() {
      const { id_type_pic, ncd_proof, rgtn_pic, domestic_id_type_pic,rgtn_with_owner_pic } = this.formData
      let params = JSON.parse(JSON.stringify(this.formData))
      // delete params.id_type_pic
      // delete params.ncd_proof
      // delete params.rgtn_pic
      delete params.nm_drvr_list
      // 將文件字段拆出來
      if(id_type_pic) {
        params.id_type_pic_path = id_type_pic.path
        params.id_type_pic_path_id = id_type_pic.id
      }
      if(ncd_proof) {
        params.ncd_proof_path = ncd_proof.path
        params.ncd_proof_path_id = ncd_proof.id
      }
      if(rgtn_pic) {
        params.rgtn_pic_path = rgtn_pic.path
        params.rgtn_pic_path_id = rgtn_pic.id
      }
      if(rgtn_with_owner_pic) {
        params.rgtn_with_owner_pic_path = rgtn_with_owner_pic.path
        params.rgtn_with_owner_pic_path_id = rgtn_with_owner_pic.id
      }
      if(domestic_id_type_pic) {
        params.domestic_id_type_pic_path = domestic_id_type_pic.path
        params.domestic_id_type_pic_path_id = domestic_id_type_pic.id
      }
      return params
    },
    handlerDeleteBRFile(otherData){
      const { target, type, index = '' } = otherData
      this.formData[target] ={}
      this.$set(this.formData.upload_document,'br_files',[])
      this.$set(this.formData,target,{})
      this.$emit('update')
    },
    handlerDeleteSMEFile(otherData){
      const { target, type,idkey, index = '' } = otherData
      if(target=='mpf_files'){
        this.formData[target].splice(index, 1)
      }else
      {
        this.formData[target] ={}
        this.$set(this.formData,idkey,'')
      }
      this.$emit('update')
    },
    handlerDeleteFile(otherData) {
      const { target, type, index = '' } = otherData
      if(type === 'drivers') {
        if(target === 'idType') {
          const idTypeData = {
            nm_drvr_id_type_pic_url: '',
            nm_drvr_id_type_pic_thumb_url: '',
            nm_drvr_id_type_pic_path_id: '',
            nm_drvr_id_type_pic_path: ''
          }
          this.handler().updateDriverData(idTypeData, index)
        }
        else {
          const licenceData = {
            nm_drvr_licence_pic_url: '',
            nm_drvr_licence_pic_thumb_url: '',
            nm_drvr_licence_pic_path_id: '',
            nm_drvr_licence_pic_path: ''
          }
          this.handler().updateDriverData(licenceData, index)
        }
      }
      else if(index === '') {
        this.formData[target] = {}
      }
      else {
        this.formData.upload_document[target].splice(index, 1)
      }
      // 刪除文件影響 stts，刷新數據 08.24 Fenterly
      this.$emit('update')
      console.log('this.formData[target]-',this.formData[target])
    },
    handlerUploadSuccess({ data, result, otherData }) {
      const { target, type, index = '' } = otherData
      if(type === 'drivers') {
        const { id, name, thumb_url, url } = data
        if(target == 'idType') {
          const idTypeData = {
            nm_drvr_id_type_pic_url: url,
            nm_drvr_id_type_pic_thumb_url: thumb_url,
            nm_drvr_id_type_pic_path_id: id,
            nm_drvr_id_type_pic_path: name
          }
          this.handler().updateDriverData(idTypeData, index)
        }
        else {
          const licenceData = {
            nm_drvr_licence_pic_url: url,
            nm_drvr_licence_pic_thumb_url: thumb_url,
            nm_drvr_licence_pic_path_id: id,
            nm_drvr_licence_pic_path: name
          }
          this.handler().updateDriverData(licenceData, index)
        }
      }
      if(type === 'nm_domestic_id_type_pic') {
        const { id, name, thumb_url, url } = data
        this.$set(this.formData.domestic_helper_info[index], 'id_type_pic', data)
      }
      if(type === 'traveler_id_type_pic') {
        const { id, name, thumb_url, url } = data
        this.$set(this.formData.nm_traveler_list[index], 'id_type_pic_path_id', id)
        this.$set(this.formData.nm_traveler_list[index], 'id_type_pic_path', name)
        this.$set(this.formData.nm_traveler_list[index], 'id_type_pic_url', url)
        // this.$set(this.formData.nm_traveler_list[index], 'client_name', client_name)
      }
      if(type === 'pa_id_type_pic') {
        const { id, name, thumb_url, url } = data
        this.$set(this.formData.nm_pa_list[index], 'id_type_pic_path_id', id)
        this.$set(this.formData.nm_pa_list[index], 'id_type_pic_path', name)
        this.$set(this.formData.nm_pa_list[index], 'id_type_pic_url', url)
        // this.$set(this.formData.nm_traveler_list[index], 'client_name', client_name)
      }
      if(type === 'microchip_copy_pic') {
        const { id, name, thumb_url, url } = data
        this.$set(this.formData.pet_info[index], 'id_type_pic', data)
      }
      if(type === 'student_id_type_pic   ') {
        const { id, name, thumb_url, url } = data
        this.$set(this.formData.student_info, 'id_type_pic_url', url)
        this.$set(this.formData.student_info, 'id_type_pic_thumb_url', thumb_url)
        this.$set(this.formData.student_info, 'id_type_pic_path_id', id)
        this.$set(this.formData.student_info, 'client_name', name)
      }
      if(type === 'acc_parent_id_type_pic  ') {
        const { id, name, thumb_url, url } = data
        this.$set(this.formData.acc_parent_info, 'id_type_pic_url', url)
        this.$set(this.formData.acc_parent_info, 'id_type_pic_thumb_url', thumb_url)
        this.$set(this.formData.acc_parent_info, 'id_type_pic_path_id', id)
        this.$set(this.formData.acc_parent_info, 'client_name', name)
      }
      if(type == 'br_files') {
        const { id, name, thumb_url, url } = data
        this.$set(this.formData, target, data)
        this.$set(this.formData.upload_document,type,[{id:id}])
      }
      if(type=='mpf_files'||type=='renewal_files'||type=='device_files'){
        this.formData.upload_document[target].push(data)
      }
      else if(index === '') {
        this.$set(this.formData, target, data)
      }
      else {
        if(!this.formData[target]) {
          this.formData[target] = []
        }
        this.$set(this.formData[target], index, data)
      }
      // 最新單上傳 Vehicle Registration Document 會影響 Complete This Policy(右側黃塊) 狀態
      // 全部需要刷新數據所以這裏注釋了
      // if(target === 'rgtn_pic' && this.policyStts == 410 && this.form.id === this.policyForm.id) {
      //   this.$emit('update')
      // }
      // 上傳文件影響 stts，刷新數據 08.24 Fenterly
      this.$emit('update')
      this.uploadName()
    },
    handlerUploadSMEIndexSuccess({ data, result, otherData }) {
      const { target, type, index = '',idKey } = otherData
      let {id} =data
      this.formData[target][index]=data
      this.$emit('update')
      this.uploadName()
    },
    handlerUploadSMESuccess({ data, result, otherData }) {
      const { target, type, index = '',idKey } = otherData
      let {id} =data
      if(target=='mpf_files'||target=='internal_files'){
        this.formData[target].push(data)
      }
      else {
        this.$set(this.formData, target, data)
        this.$set(this.formData, idKey, id)
      }
      this.$emit('update')
      this.uploadName()
    },
    handlerHomeDeleteFile(otherData) {
      const { type, index } = otherData
      if(type === 'employees') {
        this.$set(this.formData.domestic_helper_info[index], 'id_type_pic', null)
      }
      else if(type === 'pet') {
        this.$set(this.formData.pet_info[index], 'microchip_copy_pic', null)
      }
      this.$emit('update')
      this.uploadName()
    },
    handler() {
      return {
        updateDriverData: (data, index) => {
          Object.keys(data).some(key => {
            this.$set(
              this.formData.nm_drvr_list[index],
              key,
              data[key])
          })
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../../quoting/sme/info";
.document-table{
  .tr:last-child{
    border-bottom-left-radius: 0px!important;
    border-bottom-right-radius: 0px!important;
  }
}

//.document-form {
//    position: relative;
//}
</style>
